<template>
  <div class="modal">
    <div class="box-modal fade calendar__modal" id="eventsModal" tabindex="-1"
         role="dialog" aria-labelledby="eventsModalLabel"
         aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <div v-if="this.detailLoaded === false" class="wait"
                 style="display: block; height: 100px; width: 100%"></div>
            <div v-if="this.detailLoaded === true">
                <span v-if="this.detailEvent.NEIGHBOURS.LEFT && !this.filter.length"
                      class="calendar__arr calendar__left"
                      :title="this.detailEvent.NEIGHBOURS.LEFT.NAME"
                      @click="loadEventLeft()"
                ></span>
              <span v-if="this.detailEvent.NEIGHBOURS.RIGHT && !this.filter.length"
                    class="calendar__arr calendar__right"
                    :title="this.detailEvent.NEIGHBOURS.RIGHT.NAME"
                    @click="loadEventRight()"
              ></span>
              <div class="calendar__item calendar__item--active">
                <h3 class="mt-xs mb-3">{{ this.detailEvent.NAME }}</h3>
                <img v-if="this.detailEvent.DETAIL_PICTURE"
                     :src="this.detailEvent.DETAIL_PICTURE.SRC"
                     :alt="this.detailEvent.DETAIL_PICTURE.DESCRIPTION"
                     class="mb-3"
                />
                <div class="row">
                  <div class="col mb-3">
                    <div class="bold mb-xs">Когда:</div>
                    {{ this.detailEvent.WHEN }}
                  </div>
                  <div v-if="this.detailEvent.LOCATION"
                       class="col mb-3">
                    <div class="bold mb-xs">Где:</div>
                    {{ this.detailEvent.LOCATION }}
                  </div>
                </div>
                <div class="bold mb-xs">Что будет:</div>
                <div class="mb-3 events__detail"><p v-html="this.detailEvent.PREVIEW_TEXT"></p></div>
                <div class="buttons">
                  <a v-if="this.detailEvent.PROPS.URL"
                     :href="this.detailEvent.PROPS.URL"
                     target="_blank"
                     class="btn mr-1 mb-3"
                  >Подробнее</a>
                  <a :href="'/events/ical/?events=' + this.detailEvent.ID" target="_blank"
                     class="btn brd ical-add mb-3"
                  >Добавить в Календарь</a>
                </div>
              </div>
            </div>
          </div>
          <button
              type="button"
              class="ui ui-cross close arcticmodal-close"
              data-dismiss="modal"
              aria-label="Close"
              style="cursor: pointer;"
          ></button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CalendarModal',
  emits: [
    'load'
  ],
  props: {
    detailLoaded: {
      type: Boolean,
      default: false,
    },
    detailEvent: {
      type: Object,
      default() {
        return {}
      }
    },
    filter: {
      type: Array,
      default() {
        return []
      }
    }
  },
  methods: {
    loadEventLeft() {
      this.$emit('load', this.detailEvent.NEIGHBOURS.LEFT.ID);
    },
    loadEventRight() {
      this.$emit('load', this.detailEvent.NEIGHBOURS.RIGHT.ID);
    }
  }
}
</script>
<style lang="scss">
@import "../../../design_kit/libs/arcticmodal/jquery.arcticmodal-0.3.css";
</style>
